import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as HttpStatus from 'http-status-codes';
import {ErrorDataService} from '../../services/error-data.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-error-report',
  templateUrl: './error-report.component.html',
  styleUrls: ['./error-report.component.css']
})
export class ErrorReportComponent implements OnInit {

  public code: number;
  public error: Error | HttpErrorResponse;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private errorDataService: ErrorDataService) {
  }

  ngOnInit() {
    this.errorDataService.currentError.subscribe(err => this.error = err);
    this.code = this.activatedRoute.snapshot.paramMap.get('code') ? parseInt(this.activatedRoute.snapshot.paramMap.get('code'), 10) : null;
    // subscribe to route changes
    this.router.events.subscribe(() => this.updateOnRouteChange());
  }

  private updateOnRouteChange() {
    this.code = parseInt(this.activatedRoute.snapshot.paramMap.get('code'), 10);
  }

  getText() {
    if (this.code === null) {
      return this.error ? this.error.message : '';
    }
    if (this.code === 0) {
      return 'The request could not be fulfilled, possibly due to a ' +
        'CORS (Cross-Origin Resource Sharing) error, please contact the service administrator';
    }
    return isNaN(this.code) ? 'Unknown Error, please contact the service administrator' : HttpStatus.getStatusText(this.code);
  }

  getCode() {
    if (this.code === null) {
      return this.error ? (this.error instanceof HttpErrorResponse ? this.error.status : this.error.name) : '';
    }
    if (this.code === 0 || isNaN(this.code)) {
      return 'Unknown Error';
    }
    return 'Http Error status code: ' + this.code;
  }
}
